import { PROTOCOL_LINK_REGEX } from '@common/constants/url';

export const getAnchorBrowserContext = (link: string) => {
  return link.match(PROTOCOL_LINK_REGEX) ? '_blank' : '_self';
};
